import { ChangeType } from '@zapier/design-system-revenue/src/types';

type GetButtonColorProps = {
  changeType: ChangeType;
  isUserOnLegacyPlan: boolean;
  isLoggedOutPricingPage: boolean;
};

export const getButtonColor = ({
  changeType,
  isLoggedOutPricingPage,
  isUserOnLegacyPlan,
}: GetButtonColorProps) => {
  if (isLoggedOutPricingPage || isUserOnLegacyPlan) {
    return 'blue';
  }

  return changeType === 'upgrade' ? 'blue' : 'custom';
};
